import { actionTypes } from '../constants/AnalyticsGa4Constants';

const setSdkConfig = payload => {
  return {
    type: actionTypes.SET_SDK_CONFIG,
    payload
  };
};

const trackContentClick = ({ bibId, listId, cardId, eventEntity, uiEntity, metadataEntity, properties }) => {
  return {
    type: actionTypes.TRACK_CONTENT_CLICK,
    payload: {
      bibId,
      listId,
      cardId,
      event: eventEntity,
      ui: uiEntity,
      metadata: metadataEntity,
      properties
    }
  };
};

const trackCheckoutConsumeDownload = bibId => {
  return {
    type: actionTypes.TRACK_CHECKOUT_CONSUME_DOWNLOAD,
    payload: { bibId }
  };
};

const trackSdkCheckoutConsumeAccess = bibEntity => {
  return {
    type: actionTypes.TRACK_SDK_CHECKOUT_CONSUME_ACCESS,
    payload: {
      bib: bibEntity
    }
  };
};

const trackCheckoutConsumeAccess = bibId => {
  return {
    type: actionTypes.TRACK_CHECKOUT_CONSUME_ACCESS,
    payload: { bibId }
  };
};

const trackHoldingsConsumeAccess = ({ bibId, uiEntity, metadataEntity }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_CONSUME_ACCESS,
    payload: {
      bibId,
      ui: uiEntity,
      metadata: metadataEntity
    }
  };
};

const trackHoldingsExploreEdition = ({ bibId, uiEntity }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_EXPLORE_EDITION,
    payload: { bibId, ui: uiEntity }
  };
};

const trackHoldingsExploreFormat = ({ bibId, uiEntity }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_EXPLORE_FORMAT,
    payload: { bibId, ui: uiEntity }
  };
};

const trackHoldingsView = ({ bibId, uiEntity }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_VIEW,
    payload: {
      bibId,
      ui: uiEntity
    }
  };
};

const trackPageView = ({ bibId, list }) => {
  return {
    type: actionTypes.TRACK_PAGE_VIEW,
    payload: {
      bibId,
      list
    }
  };
};

const trackSdkCheckoutPlace = bibEntity => {
  return {
    type: actionTypes.TRACK_SDK_CHECKOUT_PLACE,
    payload: {
      bib: bibEntity
    }
  };
};

const trackSdkContentClick = ({ bib, list, metadata, ui }) => {
  return {
    type: actionTypes.TRACK_SDK_CONTENT_CLICK,
    payload: { bib, list, metadata, ui }
  };
};

const trackSdkHoldingsConsumeAccess = ({ bib, metadata, ui }) => {
  return {
    type: actionTypes.TRACK_SDK_HOLDINGS_CONSUME_ACCESS,
    payload: {
      bib,
      metadata,
      ui
    }
  };
};

const trackSdkHoldingsView = bibEntity => {
  return {
    type: actionTypes.TRACK_SDK_HOLDINGS_VIEW,
    payload: {
      bib: bibEntity
    }
  };
};

const trackSdkHoldPlace = bibEntity => {
  return {
    type: actionTypes.TRACK_SDK_HOLD_PLACE,
    payload: {
      bib: bibEntity
    }
  };
};

const trackSdkLogin = userEntity => {
  return {
    type: actionTypes.TRACK_SDK_LOG_IN,
    payload: {
      user: userEntity
    }
  };
};

const trackSdkUserAccountRegister = userEntity => {
  return {
    type: actionTypes.TRACK_SDK_USER_ACCOUNT_REGISTER,
    payload: {
      user: userEntity
    }
  };
};

const trackSdkUserContentAdd = ({ list }) => {
  return {
    type: actionTypes.TRACK_SDK_USER_CONTENT_ADD,
    payload: {
      list
    }
  };
};

const trackSdkUserContentModify = ({ list }) => {
  return {
    type: actionTypes.TRACK_SDK_USER_CONTENT_MODIFY,
    payload: {
      list
    }
  };
};

const trackSdkUserEngageFollow = () => {
  return {
    type: actionTypes.TRACK_SDK_USER_ENGAGE_FOLLOW
  };
};

const trackContentImpression = ({ cardId, uiEntity, properties }) => {
  return {
    type: actionTypes.TRACK_CONTENT_IMPRESSION,
    payload: {
      cardId,
      ui: uiEntity,
      properties
    }
  };
};

const trackContentExplore = ({ cardId, uiEntity, metadataEntity, properties }) => {
  return {
    type: actionTypes.TRACK_CONTENT_EXPLORE,
    payload: {
      cardId,
      ui: uiEntity,
      metadata: metadataEntity,
      properties
    }
  };
};

const trackCatalogExplore = ({ bibId, uiEntity, metadataEntity }) => {
  return {
    type: actionTypes.TRACK_CATALOG_EXPLORE,
    payload: {
      bibId,
      ui: uiEntity,
      metadata: metadataEntity
    }
  };
};

export {
  setSdkConfig,
  trackContentClick,
  trackCheckoutConsumeDownload,
  trackHoldingsConsumeAccess,
  trackHoldingsExploreEdition,
  trackHoldingsExploreFormat,
  trackHoldingsView,
  trackPageView,
  trackSdkCheckoutConsumeAccess,
  trackCheckoutConsumeAccess,
  trackSdkCheckoutPlace,
  trackSdkContentClick,
  trackSdkHoldingsConsumeAccess,
  trackSdkHoldingsView,
  trackSdkHoldPlace,
  trackSdkLogin,
  trackSdkUserAccountRegister,
  trackSdkUserContentAdd,
  trackSdkUserContentModify,
  trackSdkUserEngageFollow,
  trackContentImpression,
  trackContentExplore,
  trackCatalogExplore
};
